// // PasswordResetModal.js
// import React, { useState, useEffect, useRef } from 'react';
// import { toast } from 'react-toastify';
// import { api_url } from '../constant';

// // OTP Input Component (separate to prevent re-renders)
// const OtpInput = ({ value, onChange, disabled = false }) => {
//   const [otp, setOtp] = useState(new Array(6).fill(''));
//   const inputsRef = useRef([]);

//   useEffect(() => {
//     if (value) {
//       const newOtp = value.split('').slice(0, 6);
//       const paddedOtp = [...newOtp, ...new Array(6 - newOtp.length).fill('')];
//       setOtp(paddedOtp);
//     } else {
//       setOtp(new Array(6).fill(''));
//     }
//   }, [value]);

//   const handleChange = (index, newValue) => {
//     if (!/^[0-9]?$/.test(newValue)) return;

//     const newOtp = [...otp];
//     newOtp[index] = newValue;
//     setOtp(newOtp);
//     onChange(newOtp.join(''));

//     // Auto-focus next input
//     if (newValue && index < 5) {
//       setTimeout(() => {
//         if (inputsRef.current[index + 1]) {
//           inputsRef.current[index + 1].focus();
//         }
//       }, 0);
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === 'Backspace') {
//       if (!otp[index] && index > 0) {
//         // Move to previous input on backspace if current is empty
//         if (inputsRef.current[index - 1]) {
//           inputsRef.current[index - 1].focus();
//         }
//       }
//     }
//   };

//   const handlePaste = (e) => {
//     e.preventDefault();
//     const pastedData = e.clipboardData.getData('text/plain').replace(/\D/g, '');
//     const pastedOtp = pastedData.substring(0, 6).split('');
    
//     if (pastedOtp.length) {
//       const newOtp = [...otp];
//       pastedOtp.forEach((char, index) => {
//         if (index < 6) {
//           newOtp[index] = char;
//         }
//       });
//       setOtp(newOtp);
//       onChange(newOtp.join(''));
      
//       // Focus the last input after paste
//       const lastIndex = Math.min(pastedOtp.length, 6) - 1;
//       setTimeout(() => {
//         if (inputsRef.current[lastIndex]) {
//           inputsRef.current[lastIndex].focus();
//         }
//       }, 0);
//     }
//   };

//   return (
//     <div className="flex gap-2 justify-center">
//       {otp.map((digit, index) => (
//         <input
//           key={index}
//           ref={(el) => (inputsRef.current[index] = el)}
//           type="text"
//           maxLength={1}
//           value={digit}
//           onChange={(e) => handleChange(index, e.target.value)}
//           onKeyDown={(e) => handleKeyDown(index, e)}
//           onPaste={handlePaste}
//           onFocus={(e) => e.target.select()}
//           className="w-12 h-12 border-2 border-gray-300 rounded-xl text-center text-2xl focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
//           dir="ltr"
//           disabled={disabled}
//           autoComplete="off"
//           inputMode="numeric"
//           pattern="[0-9]*"
//         />
//       ))}
//     </div>
//   );
// };

// const PasswordResetModal = ({ isOpen, onClose, initialPhone = '' }) => {
//   // State management
//   const [resetStep, setResetStep] = useState(1); // 1: Choose method, 2: Phone input, 3: OTP, 4: New Password
//   const [resetMethod, setResetMethod] = useState('');
//   const [resetPhone, setResetPhone] = useState(initialPhone);
//   const [resetOtp, setResetOtp] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [countdown, setCountdown] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);

//   // WhatsApp reset method
//   const handleWhatsAppReset = () => {
//     const adminWhatsAppNumber = "249117028638";
//     const phoneToSend = resetPhone || initialPhone || '';
//     const message = `مرحبا، أريد استعادة كلمة المرور لحسابي. رقم هاتفي: ${phoneToSend || 'لم يتم إدخاله'}`;
//     const encodedMessage = encodeURIComponent(message);
//     const whatsappUrl = `https://wa.me/${adminWhatsAppNumber}?text=${encodedMessage}`;

//     window.open(whatsappUrl, '_blank');

//     toast.info("سيتم فتح واتساب للتواصل مع المسؤول لاستعادة كلمة المرور", {
//       position: "top-center",
//       autoClose: 5000,
//     });

//     onClose();
//   };

//   // Format phone number helper
//   const formatPhoneNumber = (phone) => {
//     if (phone.startsWith('0')) {
//       return "+249" + phone.substring(1);
//     } else if (!phone.startsWith('+')) {
//       return "+249" + phone;
//     }
//     return phone;
//   };

//   // Request OTP for password reset
//   const requestPasswordResetOtp = async () => {
//     if (!resetPhone) {
//       toast.error('الرجاء إدخال رقم الهاتف', {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const formattedPhone = formatPhoneNumber(resetPhone);

//       const response = await fetch(api_url + "/auth/password/reset/request", {
//         method: "POST",
//         body: JSON.stringify({ phonenumber: formattedPhone }),
//         headers: { 'Content-Type': 'application/json' }
//       });

//       const data = await response.json();

//       if (data.success) {
//         setResetStep(3);
//         startCountdown(60);
//         toast.success(data.message, {
//           position: "top-center",
//           autoClose: 5000,
//         });
//       } else {
//         toast.error(data.message, {
//           position: "top-center",
//           autoClose: 5000,
//         });
//       }
//     } catch (error) {
//       toast.error("حدث خطأ أثناء طلب رمز التحقق", {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       console.error("Request OTP error:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Verify OTP
//   const verifyResetOtp = async () => {
//     if (!resetOtp || resetOtp.length !== 6) {
//       toast.error('الرجاء إدخال رمز التحقق المكون من 6 أرقام', {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const formattedPhone = formatPhoneNumber(resetPhone);

//       const response = await fetch(api_url + "/auth/password/reset/verify", {
//         method: "POST",
//         body: JSON.stringify({
//           phonenumber: formattedPhone,
//           otp: resetOtp
//         }),
//         headers: { 'Content-Type': 'application/json' }
//       });

//       const data = await response.json();

//       if (data.success) {
//         setResetStep(4);
//         toast.success("تم التحقق بنجاح. يمكنك الآن إدخال كلمة المرور الجديدة", {
//           position: "top-center",
//           autoClose: 5000,
//         });
//       } else {
//         toast.error(data.message, {
//           position: "top-center",
//           autoClose: 5000,
//         });
//       }
//     } catch (error) {
//       toast.error("حدث خطأ أثناء التحقق", {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       console.error("Verify OTP error:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Reset password
//   const resetPassword = async () => {
//     if (!newPassword || !confirmPassword) {
//       toast.error('الرجاء إدخال كلمة المرور الجديدة وتأكيدها', {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       toast.error('كلمتا المرور غير متطابقتين', {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       return;
//     }

//     if (newPassword.length < 6) {
//       toast.error('كلمة المرور يجب أن تكون على الأقل 6 أحرف', {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const formattedPhone = formatPhoneNumber(resetPhone);

//       const response = await fetch(api_url + "/auth/password/reset", {
//         method: "POST",
//         body: JSON.stringify({
//           phonenumber: formattedPhone,
//           otp: resetOtp,
//           newPassword: newPassword,
//           confirmPassword: confirmPassword
//         }),
//         headers: { 'Content-Type': 'application/json' }
//       });

//       const data = await response.json();

//       if (data.success) {
//         toast.success("تم إعادة تعيين كلمة المرور بنجاح", {
//           position: "top-center",
//           autoClose: 5000,
//         });
//         handleClose();
//       } else {
//         toast.error(data.message, {
//           position: "top-center",
//           autoClose: 5000,
//         });
//       }
//     } catch (error) {
//       toast.error("حدث خطأ أثناء إعادة تعيين كلمة المرور", {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       console.error("Reset password error:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Countdown timer
//   const startCountdown = (seconds) => {
//     setCountdown(seconds);
//     const interval = setInterval(() => {
//       setCountdown((prev) => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);
//   };

//   // Resend OTP
//   const resendOtp = async () => {
//     if (countdown > 0) {
//       toast.error(`الرجاء الانتظار ${countdown} ثانية قبل إعادة الإرسال`, {
//         position: "top-center",
//         autoClose: 5000,
//       });
//       return;
//     }
//     await requestPasswordResetOtp();
//   };

//   // Reset form and close
//   const handleClose = () => {
//     setResetStep(1);
//     setResetMethod('');
//     setResetPhone(initialPhone);
//     setResetOtp('');
//     setNewPassword('');
//     setConfirmPassword('');
//     setCountdown(0);
//     setIsLoading(false);
//     onClose();
//   };

//   // Don't render if not open
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl p-6 w-full max-w-md">
//         <div className="flex justify-between items-center mb-6">
//           <h2 className="text-xl font-bold text-right">
//             {resetStep === 1 && 'استعادة كلمة المرور'}
//             {resetStep === 2 && 'إدخال رقم الهاتف'}
//             {resetStep === 3 && 'التحقق من الرمز'}
//             {resetStep === 4 && 'كلمة المرور الجديدة'}
//           </h2>
//           <button
//             onClick={handleClose}
//             className="text-gray-500 hover:text-gray-700 text-xl"
//             disabled={isLoading}
//           >
//             ✕
//           </button>
//         </div>

//         {/* Step 1: Choose Method */}
//         {resetStep === 1 && (
//           <div className="space-y-4">
//             <p className="text-gray-600 text-right mb-6">
//               اختر طريقة استعادة كلمة المرور:
//             </p>
            
//             <button
//               onClick={() => {
//                 setResetMethod('otp');
//                 setResetStep(2);
//               }}
//               className="w-full bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
//               disabled={isLoading}
//             >
//               <span>استعادة عبر رمز التحقق (OTP)</span>
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
//               </svg>
//             </button>
            
//             <div className="text-center">
//               <span className="text-gray-500">أو</span>
//             </div>
            
//             <button
//               onClick={handleWhatsAppReset}
//               className="w-full bg-green-600 text-white py-3 rounded-xl font-bold hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
//               disabled={isLoading}
//             >
//               <span>التواصل مع المسؤول عبر واتساب</span>
//               <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411" />
//               </svg>
//             </button>
            
//             <p className="text-gray-500 text-sm text-right mt-4">
//               نوصي باستخدام رمز التحقق للحصول على خدمة أسرع وأكثر أماناً
//             </p>
//           </div>
//         )}

//         {/* Step 2: Phone Input for OTP */}
//         {resetStep === 2 && (
//           <div className="space-y-4">
//             <p className="text-gray-600 text-right">
//               أدخل رقم هاتفك المسجل وسنرسل لك رمز تحقق لإعادة تعيين كلمة المرور
//             </p>
//             <input
//               type="tel"
//               value={resetPhone}
//               onChange={(e) => setResetPhone(e.target.value)}
//               placeholder="رقم الهاتف (09xxxxxx)"
//               className="w-full border-2 border-gray-300 rounded-xl p-3 text-right focus:border-primary focus:outline-none"
//               dir="rtl"
//               disabled={isLoading}
//               autoFocus
//             />
//             <div className="flex gap-2">
//               <button
//                 onClick={() => {
//                   setResetStep(1);
//                   setResetMethod('');
//                 }}
//                 className="flex-1 border-2 border-gray-300 text-gray-700 py-3 rounded-xl font-bold hover:bg-gray-50 transition-colors"
//                 disabled={isLoading}
//               >
//                 رجوع
//               </button>
//               <button
//                 onClick={requestPasswordResetOtp}
//                 className="flex-1 bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                 disabled={isLoading || !resetPhone}
//               >
//                 {isLoading ? (
//                   <span className="flex items-center justify-center">
//                     <svg className="animate-spin h-5 w-5 mr-2 text-white" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                     </svg>
//                     جاري الإرسال...
//                   </span>
//                 ) : 'إرسال رمز التحقق'}
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Step 3: OTP Verification */}
//         {resetStep === 3 && (
//           <div className="space-y-4">
//             <p className="text-gray-600 text-right">
//               أدخل رمز التحقق المكون من 6 أرقام الذي تم إرساله إلى {resetPhone}
//             </p>
            
//             <OtpInput
//               value={resetOtp}
//               onChange={setResetOtp}
//               disabled={isLoading}
//             />
            
//             <div className="text-center">
//               {countdown > 0 ? (
//                 <p className="text-gray-500">
//                   يمكنك إعادة الإرسال بعد {countdown} ثانية
//                 </p>
//               ) : (
//                 <button
//                   onClick={resendOtp}
//                   className="text-primary hover:text-blue-700 underline disabled:opacity-50 disabled:cursor-not-allowed"
//                   disabled={isLoading}
//                 >
//                   إعادة إرسال الرمز
//                 </button>
//               )}
//             </div>
            
//             <div className="flex gap-2">
//               <button
//                 onClick={() => {
//                   setResetStep(2);
//                   setResetOtp('');
//                 }}
//                 className="flex-1 border-2 border-gray-300 text-gray-700 py-3 rounded-xl font-bold hover:bg-gray-50 transition-colors"
//                 disabled={isLoading}
//               >
//                 رجوع
//               </button>
//               <button
//                 onClick={verifyResetOtp}
//                 className="flex-1 bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                 disabled={isLoading || resetOtp.length !== 6}
//               >
//                 {isLoading ? (
//                   <span className="flex items-center justify-center">
//                     <svg className="animate-spin h-5 w-5 mr-2 text-white" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                     </svg>
//                     جاري التحقق...
//                   </span>
//                 ) : 'تحقق من الرمز'}
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Step 4: New Password */}
//         {resetStep === 4 && (
//           <div className="space-y-4">
//             <p className="text-gray-600 text-right">
//               أدخل كلمة المرور الجديدة
//             </p>
//             <input
//               type="password"
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//               placeholder="كلمة المرور الجديدة (6 أحرف على الأقل)"
//               className="w-full border-2 border-gray-300 rounded-xl p-3 text-right focus:border-primary focus:outline-none"
//               dir="rtl"
//               disabled={isLoading}
//               autoFocus
//             />
//             <input
//               type="password"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//               placeholder="تأكيد كلمة المرور الجديدة"
//               className="w-full border-2 border-gray-300 rounded-xl p-3 text-right focus:border-primary focus:outline-none"
//               dir="rtl"
//               disabled={isLoading}
//             />
//             <div className="flex gap-2">
//               <button
//                 onClick={() => {
//                   setResetStep(3);
//                   setNewPassword('');
//                   setConfirmPassword('');
//                 }}
//                 className="flex-1 border-2 border-gray-300 text-gray-700 py-3 rounded-xl font-bold hover:bg-gray-50 transition-colors"
//                 disabled={isLoading}
//               >
//                 رجوع
//               </button>
//               <button
//                 onClick={resetPassword}
//                 className="flex-1 bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                 disabled={isLoading || !newPassword || !confirmPassword || newPassword.length < 6}
//               >
//                 {isLoading ? (
//                   <span className="flex items-center justify-center">
//                     <svg className="animate-spin h-5 w-5 mr-2 text-white" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                     </svg>
//                     جاري الحفظ...
//                   </span>
//                 ) : 'حفظ كلمة المرور الجديدة'}
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PasswordResetModal;
// PasswordResetModal.js
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { api_url } from '../constant';

// OTP Input Component (separate to prevent re-renders)
const OtpInput = ({ value, onChange, disabled = false }) => {
  const { i18n } = useTranslation();
  const [otp, setOtp] = useState(new Array(6).fill(''));
  const inputsRef = useRef([]);

  useEffect(() => {
    if (value) {
      const newOtp = value.split('').slice(0, 6);
      const paddedOtp = [...newOtp, ...new Array(6 - newOtp.length).fill('')];
      setOtp(paddedOtp);
    } else {
      setOtp(new Array(6).fill(''));
    }
  }, [value]);

  const handleChange = (index, newValue) => {
    if (!/^[0-9]?$/.test(newValue)) return;

    const newOtp = [...otp];
    newOtp[index] = newValue;
    setOtp(newOtp);
    onChange(newOtp.join(''));

    // Auto-focus next input
    if (newValue && index < 5) {
      setTimeout(() => {
        if (inputsRef.current[index + 1]) {
          inputsRef.current[index + 1].focus();
        }
      }, 0);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        // Move to previous input on backspace if current is empty
        if (inputsRef.current[index - 1]) {
          inputsRef.current[index - 1].focus();
        }
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text/plain').replace(/\D/g, '');
    const pastedOtp = pastedData.substring(0, 6).split('');
    
    if (pastedOtp.length) {
      const newOtp = [...otp];
      pastedOtp.forEach((char, index) => {
        if (index < 6) {
          newOtp[index] = char;
        }
      });
      setOtp(newOtp);
      onChange(newOtp.join(''));
      
      // Focus the last input after paste
      const lastIndex = Math.min(pastedOtp.length, 6) - 1;
      setTimeout(() => {
        if (inputsRef.current[lastIndex]) {
          inputsRef.current[lastIndex].focus();
        }
      }, 0);
    }
  };

  return (
    <div className="flex gap-2 justify-center">
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          type="text"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          onFocus={(e) => e.target.select()}
          className="w-12 h-12 border-2 border-gray-300 rounded-xl text-center text-2xl focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
          dir="ltr"
          disabled={disabled}
          autoComplete="off"
          inputMode="numeric"
          pattern="[0-9]*"
        />
      ))}
    </div>
  );
};

const PasswordResetModal = ({ isOpen, onClose, initialPhone = '' }) => {
  const { t, i18n } = useTranslation();
  
  // State management
  const [resetStep, setResetStep] = useState(1); // 1: Choose method, 2: Phone input, 3: OTP, 4: New Password
  const [resetMethod, setResetMethod] = useState('');
  const [resetPhone, setResetPhone] = useState(initialPhone);
  const [resetOtp, setResetOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // WhatsApp reset method
  const handleWhatsAppReset = () => {
    const adminWhatsAppNumber = "249117028638";
    const phoneToSend = resetPhone || initialPhone || '';
    const message = t("passwordReset.whatsappMessage", { phone: phoneToSend || t("passwordReset.notEntered") });
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${adminWhatsAppNumber}?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank');

    toast.info(t("passwordReset.whatsappInfo"), {
      position: "top-center",
      autoClose: 5000,
    });

    onClose();
  };

  // Format phone number helper
  const formatPhoneNumber = (phone) => {
    if (phone.startsWith('0')) {
      return "+249" + phone.substring(1);
    } else if (!phone.startsWith('+')) {
      return "+249" + phone;
    }
    return phone;
  };

  // Request OTP for password reset
  const requestPasswordResetOtp = async () => {
    if (!resetPhone) {
      toast.error(t("passwordReset.errors.enterPhone"), {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    setIsLoading(true);
    try {
      const formattedPhone = formatPhoneNumber(resetPhone);

      const response = await fetch(api_url + "/auth/password/reset/request", {
        method: "POST",
        body: JSON.stringify({ phonenumber: formattedPhone }),
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success) {
        setResetStep(3);
        startCountdown(60);
        toast.success(data.message, {
          position: "top-center",
          autoClose: 5000,
        });
      } else {
        toast.error(data.message, {
          position: "top-center",
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error(t("passwordReset.errors.requestError"), {
        position: "top-center",
        autoClose: 5000,
      });
      console.error("Request OTP error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Verify OTP
  const verifyResetOtp = async () => {
    if (!resetOtp || resetOtp.length !== 6) {
      toast.error(t("passwordReset.errors.enterValidOtp"), {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    setIsLoading(true);
    try {
      const formattedPhone = formatPhoneNumber(resetPhone);

      const response = await fetch(api_url + "/auth/password/reset/verify", {
        method: "POST",
        body: JSON.stringify({
          phonenumber: formattedPhone,
          otp: resetOtp
        }),
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success) {
        setResetStep(4);
        toast.success(t("passwordReset.success.verificationSuccess"), {
          position: "top-center",
          autoClose: 5000,
        });
      } else {
        toast.error(data.message, {
          position: "top-center",
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error(t("passwordReset.errors.verificationError"), {
        position: "top-center",
        autoClose: 5000,
      });
      console.error("Verify OTP error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Reset password
  const resetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error(t("passwordReset.errors.enterNewPassword"), {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error(t("passwordReset.errors.passwordMismatch"), {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    if (newPassword.length < 6) {
      toast.error(t("passwordReset.errors.passwordMinLength"), {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    setIsLoading(true);
    try {
      const formattedPhone = formatPhoneNumber(resetPhone);

      const response = await fetch(api_url + "/auth/password/reset", {
        method: "POST",
        body: JSON.stringify({
          phonenumber: formattedPhone,
          otp: resetOtp,
          newPassword: newPassword,
          confirmPassword: confirmPassword
        }),
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success) {
        toast.success(t("passwordReset.success.passwordResetSuccess"), {
          position: "top-center",
          autoClose: 5000,
        });
        handleClose();
      } else {
        toast.error(data.message, {
          position: "top-center",
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error(t("passwordReset.errors.resetError"), {
        position: "top-center",
        autoClose: 5000,
      });
      console.error("Reset password error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Countdown timer
  const startCountdown = (seconds) => {
    setCountdown(seconds);
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Resend OTP
  const resendOtp = async () => {
    if (countdown > 0) {
      toast.error(t("passwordReset.errors.waitBeforeResend", { seconds: countdown }), {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }
    await requestPasswordResetOtp();
  };

  // Reset form and close
  const handleClose = () => {
    setResetStep(1);
    setResetMethod('');
    setResetPhone(initialPhone);
    setResetOtp('');
    setNewPassword('');
    setConfirmPassword('');
    setCountdown(0);
    setIsLoading(false);
    onClose();
  };

  // Don't render if not open
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-right">
            {resetStep === 1 && t("passwordReset.titles.chooseMethod")}
            {resetStep === 2 && t("passwordReset.titles.enterPhone")}
            {resetStep === 3 && t("passwordReset.titles.verifyCode")}
            {resetStep === 4 && t("passwordReset.titles.newPassword")}
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
            disabled={isLoading}
          >
            ✕
          </button>
        </div>

        {/* Step 1: Choose Method */}
        {resetStep === 1 && (
          <div className="space-y-4">
            <p className="text-gray-600 text-right mb-6">
              {t("passwordReset.chooseMethodDescription")}
            </p>
            
            <button
              onClick={() => {
                setResetMethod('otp');
                setResetStep(2);
              }}
              className="w-full bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
              disabled={isLoading}
            >
              <span>{t("passwordReset.otpMethod")}</span>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </button>
            
            <div className="text-center">
              <span className="text-gray-500">{t("passwordReset.or")}</span>
            </div>
            
            <button
              onClick={handleWhatsAppReset}
              className="w-full bg-green-600 text-white py-3 rounded-xl font-bold hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
              disabled={isLoading}
            >
              <span>{t("passwordReset.whatsappMethod")}</span>
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411" />
              </svg>
            </button>
            
            <p className="text-gray-500 text-sm text-right mt-4">
              {t("passwordReset.recommendation")}
            </p>
          </div>
        )}

        {/* Step 2: Phone Input for OTP */}
        {resetStep === 2 && (
          <div className="space-y-4">
            <p className="text-gray-600 text-right">
              {t("passwordReset.enterPhoneDescription")}
            </p>
            <input
              type="tel"
              value={resetPhone}
              onChange={(e) => setResetPhone(e.target.value)}
              placeholder={t("passwordReset.phonePlaceholder")}
              className="w-full border-2 border-gray-300 rounded-xl p-3 text-right focus:border-primary focus:outline-none"
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              disabled={isLoading}
              autoFocus
            />
            <div className="flex gap-2">
              <button
                onClick={() => {
                  setResetStep(1);
                  setResetMethod('');
                }}
                className="flex-1 border-2 border-gray-300 text-gray-700 py-3 rounded-xl font-bold hover:bg-gray-50 transition-colors"
                disabled={isLoading}
              >
                {t("passwordReset.back")}
              </button>
              <button
                onClick={requestPasswordResetOtp}
                className="flex-1 bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isLoading || !resetPhone}
              >
                {isLoading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin h-5 w-5 mr-2 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    {t("passwordReset.sending")}
                  </span>
                ) : t("passwordReset.sendCode")}
              </button>
            </div>
          </div>
        )}

        {/* Step 3: OTP Verification */}
        {resetStep === 3 && (
          <div className="space-y-4">
            <p className="text-gray-600 text-right">
              {t("passwordReset.enterOtpDescription", { phone: resetPhone })}
            </p>
            
            <OtpInput
              value={resetOtp}
              onChange={setResetOtp}
              disabled={isLoading}
            />
            
            <div className="text-center">
              {countdown > 0 ? (
                <p className="text-gray-500">
                  {t("passwordReset.resendWait", { seconds: countdown })}
                </p>
              ) : (
                <button
                  onClick={resendOtp}
                  className="text-primary hover:text-blue-700 underline disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isLoading}
                >
                  {t("passwordReset.resendCode")}
                </button>
              )}
            </div>
            
            <div className="flex gap-2">
              <button
                onClick={() => {
                  setResetStep(2);
                  setResetOtp('');
                }}
                className="flex-1 border-2 border-gray-300 text-gray-700 py-3 rounded-xl font-bold hover:bg-gray-50 transition-colors"
                disabled={isLoading}
              >
                {t("passwordReset.back")}
              </button>
              <button
                onClick={verifyResetOtp}
                className="flex-1 bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isLoading || resetOtp.length !== 6}
              >
                {isLoading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin h-5 w-5 mr-2 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    {t("passwordReset.verifying")}
                  </span>
                ) : t("passwordReset.verifyCode")}
              </button>
            </div>
          </div>
        )}

        {/* Step 4: New Password */}
        {resetStep === 4 && (
          <div className="space-y-4">
            <p className="text-gray-600 text-right">
              {t("passwordReset.enterNewPasswordDescription")}
            </p>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder={t("passwordReset.newPasswordPlaceholder")}
              className="w-full border-2 border-gray-300 rounded-xl p-3 text-right focus:border-primary focus:outline-none"
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              disabled={isLoading}
              autoFocus
            />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder={t("passwordReset.confirmPasswordPlaceholder")}
              className="w-full border-2 border-gray-300 rounded-xl p-3 text-right focus:border-primary focus:outline-none"
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              disabled={isLoading}
            />
            <div className="flex gap-2">
              <button
                onClick={() => {
                  setResetStep(3);
                  setNewPassword('');
                  setConfirmPassword('');
                }}
                className="flex-1 border-2 border-gray-300 text-gray-700 py-3 rounded-xl font-bold hover:bg-gray-50 transition-colors"
                disabled={isLoading}
              >
                {t("passwordReset.back")}
              </button>
              <button
                onClick={resetPassword}
                className="flex-1 bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isLoading || !newPassword || !confirmPassword || newPassword.length < 6}
              >
                {isLoading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin h-5 w-5 mr-2 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    {t("passwordReset.saving")}
                  </span>
                ) : t("passwordReset.savePassword")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordResetModal;